var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("article", [
    _c("div", { staticClass: "form-container slider-form" }, [
      _c("div", { staticClass: "row mx-0 fe-range-slide" }, [
        _c("div", { staticClass: "form-box col-sm-3 pl-0" }, [
          _c(
            "div",
            { class: _vm.containerClass },
            [
              _c("text-section", {
                key: _vm.value,
                ref: "number",
                attrs: {
                  type: "text",
                  name: _vm.name,
                  mincheck: _vm.min,
                  maxcheck: _vm.max,
                  disabled: _vm.disabled,
                  "class-name": _vm.className,
                  value: !_vm.value ? 0 : _vm.value,
                },
                on: { change: _vm.handleChange },
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _vm.recommendedBrowser()
          ? _c(
              "div",
              { staticClass: "slide-container pr-0 col-sm d-sm-block d-none" },
              [
                _c("input", {
                  ref: "slider",
                  staticClass: "slider fe-slide-linked",
                  style: "background-image: " + _vm.gradient,
                  attrs: {
                    id: _vm.nameSlide,
                    type: "range",
                    min: "0",
                    max: _vm.max,
                    step: "1",
                    disabled: _vm.disabled,
                  },
                  domProps: { value: !_vm.value ? 0 : _vm.value },
                  on: {
                    input: function ($event) {
                      return _vm.handleChange($event.target.value)
                    },
                  },
                }),
              ]
            )
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }